// extracted by mini-css-extract-plugin
export default {"videoContainer":"videoContainer__Jwgry","video":"video__iF7rZ","subtitle":"subtitle__nkGTl","subtitleMobile":"subtitleMobile__RevxN"};